function FormInput({ label, value, onChange, type = "text", placeholder, required = false, disabled = false }) {
    return (
        <div className="form-group animate-fade-in">
            {label && <label>{label}</label>}
            <input
                type={type}
                className="form-control"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
            />
        </div>
    );
}

export default FormInput;